import { gql } from '@apollo/client';

const Student = gql`
  fragment Student on Student {
    id
    name
    country
    city
    skype
    phone
    balance
    englishLevel {
      id
      title
    }
  }
`;

const Course = gql`
  fragment Course on Course {
    id
    titleEn
    alias
    lessonsCounter
  }
`;

const Session = gql`
  fragment Session on Session {
    id
    progress
    status
    lessonsFinishedCount
    lastLessonDate
  }
`;

const List = gql`
  fragment List on TeacherStudentsList {
    id
    comment
    schedule
    trial
  }
`;

export default {
  Student,
  Course,
  Session,
  List,
};
